import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { fetchVisitSuccess } from '../actions';
import { DELETE_UNIT } from '../constants/actionTypes';
import { getVisit } from '../repository';


function *_fetchVisitOnDeleteUnit({vtrac}) {

    try {
        let visit = yield call(getVisit(vtrac));

        yield put(fetchVisitSuccess(visit));
    } catch (error) {
        //Do nothing
    }
}

export function *fetchVisitOnDeleteUnit() {
    yield takeEvery(DELETE_UNIT.SUCCESS, _fetchVisitOnDeleteUnit);
}
